import { tWithKey } from "@/lib/i18n-fallback";
import { MultipleprintPortfolioSummary } from "@/lib/types";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/** En-tête de la fiche d'un multiple simple : rappel des portfolios qui le contiennent. */
export function PartOfPortfoliosLine({
  portfolios,
}: {
  portfolios: MultipleprintPortfolioSummary[];
}) {
  const { t } = useTranslation();
  if (portfolios.length === 0) return null;

  return (
    <p className="text-sm text-slate-700">
      {tWithKey(
        t,
        "multipleprint.portfolio.partOf",
        "Fait partie du portfolio",
      )}{" "}
      :{" "}
      {portfolios.map((portfolio, index) => (
        <span key={portfolio.id}>
          {index > 0 && ", "}
          <Link
            to={`/edit/multipleprint/${portfolio.id}`}
            // Même style que « Lire plus » (ReadMoreHtml).
            className="text-muted-foreground font-semibold no-underline hover:opacity-80"
          >
            {portfolio.estampesMultiplesDescriptionTitre ||
              portfolio.estampesMultiplesDescriptionNumeroEnregistrement}
          </Link>
        </span>
      ))}
    </p>
  );
}
